var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRadarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.07 12.93L25.66 14.34C27.1 15.79 28 17.79 28 20C28 24.42 24.42 28 20 28C15.58 28 12 24.42 12 20C12 15.92 15.05 12.56 19 12.07V14.09C16.16 14.57 14 17.03 14 20C14 23.31 16.69 26 20 26C23.31 26 26 23.31 26 20C26 18.34 25.33 16.84 24.24 15.76L22.83 17.17C23.55 17.9 24 18.9 24 20C24 22.21 22.21 24 20 24C17.79 24 16 22.21 16 20C16 18.14 17.28 16.59 19 16.14V18.28C18.4 18.63 18 19.26 18 20C18 21.1 18.9 22 20 22C21.1 22 22 21.1 22 20C22 19.26 21.6 18.62 21 18.28V10H20C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 17.24 28.88 14.74 27.07 12.93Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRadarCircle);
export default __webpack_public_path__ + "static/media/ic_radar_circle.c411539a1eb2a5964e9b34ed791f71a8.svg";
export { ForwardRef as ReactComponent };